import React from 'react';
import Apply from '../components/CampusManagers/Apply/index.jsx';
import SEO from '../components/SEO/index';

const ApplyPage = () =>
	<div>
		<SEO 
			title="Apply - Greek Dressing"
			description="Want to become a Greek Dressing Campus Manager? Let’s talk! Campus managers are the “go to” person for clients at their school. They hustle hard, and l(earn) a hell of a lot along the way." />
		<Apply />
	</div>

export default ApplyPage;